import crud_actions from './crud_actions'

export const followUser = crud_actions.create('following/user', 'followUser')
export const unfollowUser = crud_actions.delete(
  'following/user',
  'unfollowUser'
)
export const isFollowingUser = crud_actions.read(
  'following/user',
  'isFollowingUser'
)

export const followTag = crud_actions.create('following/tag', 'followTag')
export const unfollowTag = crud_actions.delete('following/tag', 'unfollowTag')
export const isFollowingTag = crud_actions.read(
  'following/tag',
  'isFollowingTag'
)
export const isFollowingTags = crud_actions.read(
  'following/tags',
  'isFollowingTags'
)
